const settings = {
  eslint: {
    reportUnusedDisableDirectives: true,
  },
  historyApiFallback: {
    disableDotRule: true,
  },
};

module.exports = settings;
